<script setup lang="ts">
import { useCalculationStore } from '@/stores/calculation'

const calculationStore = useCalculationStore()
</script>

<template>
  <div class="header-font">Welcome to your new project!</div>
  <div class="paragraph-font">
    Before you can add a new calculation, please check if you are happy with the default values in
    the
    <router-link :to="{ name: 'materials', params: { id: $route.params.id } }"
      >Materials
    </router-link>
    and
    <router-link :to="{ name: 'costs', params: { id: $route.params.id } }">Costs</router-link>
    sections.
  </div>
  <div class="paragraph-font">
    Once you're happy with them, please approve the default values by clicking the button below.
    Thank you!
  </div>
  <v-btn
    class="text-none my-4"
    variant="flat"
    @click="calculationStore.toggleIsApprovedProjectParams()"
  >
    Approve default values
  </v-btn>
</template>

<style scoped>
.header-font {
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
}

.paragraph-font {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 400;
}

a {
  color: #009eab;
  text-decoration: none;
}

a:visited,
a:active {
  color: #009eab;
  font-weight: normal;
}
</style>
